import { useEffect, useState } from "react";
import { msalInstance, initializeMsal } from "./utils/tokenManager";

export default function AppInitializer({ children }) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const init = async () => {
      await initializeMsal();

      const response = await msalInstance.handleRedirectPromise();

      if (response?.account) {
        msalInstance.setActiveAccount(response.account);
      }

      setReady(true);
    };

    init();
  }, []);

  if (!ready) return <div>Loading...</div>;

  return children;
}